<app-header [menuList$]="menuList$" [memberInfo$]="memberInfo$"></app-header>

<app-sub-header [currMenu]="currMenu$" [memberInfo]="memberInfo$"></app-sub-header>

<div class="inner-wrap">

  <form [formGroup]="form" (ngSubmit)="setLogin()">

  <div class="login">
    <input type="text" id="id" formControlName="id" placeholder="아이디를 입력하세요" [ngClass]="{formErrors:formErrors['id']}" [autofocus]="true" />
    <div *ngIf="formErrors['id']" class="error-message">{{formErrors['id']}}</div>
    <input type="password" id="pw" formControlName="pw" placeholder="비밀번호를 입력하세요" [ngClass]="{formErrors:formErrors['pw']}" />
    <div *ngIf="formErrors['pw']" class="error-message">{{formErrors['pw']}}</div>

    <button class="login-btn">로그인</button>

    <div class="btn-area">
      <a routerLink="/member/findid" class="find-btn">아이디/비밀번호 찾기</a>
      <a routerLink="/member/join" class="join-btn">회원가입</a>
    </div>

  </div>

  </form>

</div>

<app-footer></app-footer>